import { responsiveModalsCleared } from '../../model';

export const clearResponsiveModals = () => {
    responsiveModalsCleared();
};
